import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { LeftOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { UnsavedChangesModal } from "ui/UnsavedChangesModal"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import AddStaffForm from "./AddStaffForm"
import styles from "./AddStaffModal.module.css"

const AddStaffFullScreen = ({ open, onCancel, onSave, userId, staffId, editMode = false }) => {
  const { t } = useTranslation()
  const screens = useBreakpoint()
  const [isDirty, setIsDirty] = useState(false)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)
  const isMobileOrTablet = !screens.lg

  useEffect(() => {
    if (open) setIsDirty(false)
  }, [open])

  if (!open) return null

  const handleRequestClose = () => {
    if (isDirty) {
      setShowUnsavedModal(true)
    } else {
      onCancel()
    }
  }

  const handleDiscard = () => {
    setShowUnsavedModal(false)
    setIsDirty(false)
    onCancel()
  }

  return (
    <>
      <div className={styles.fullScreenContainer}>
        <div className={styles.fullScreenHeader}>
          {isMobileOrTablet && (
            <button className={styles.fullScreenBackButton} onClick={handleRequestClose} aria-label={t("common.back")}>
              <LeftOutlined style={{ fontSize: 20 }} />
            </button>
          )}
          <Text className={styles.fullScreenTitle}>{editMode ? t("staff.edit_staff_modal.title") : t("staff.add_staff_modal.title")}</Text>
        </div>
        <AddStaffForm
          key={staffId || "new"}
          open={open}
          onCancel={onCancel}
          onRequestClose={handleRequestClose}
          markDirty={() => setIsDirty(true)}
          onSave={onSave}
          userId={userId}
          staffId={staffId}
          editMode={editMode}
          isFullScreen={true}
        />
      </div>

      <UnsavedChangesModal
        open={showUnsavedModal}
        onDiscard={handleDiscard}
        onKeepEditing={() => setShowUnsavedModal(false)}
      />
    </>
  )
}

export default AddStaffFullScreen
